import { Link } from 'react-router-dom';

const LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Game Overview', path: '/game-overview' },
  { label: 'Level Selector', path: '/level-selector' },
  { label: 'Multiplication', path: '/multiplication-challenge' },
  { label: 'Volume Challenge', path: '/volume-challenge' },
  { label: 'Division Challenge', path: '/division-challenge' },
];

export default function Footer() {
  return (
    <footer className="bg-green-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img
              src="https://public.readdy.ai/ai/img_res/6db66753-9ba6-419d-8cc5-2b89b104d003.png"
              alt="Math Tennis Logo"
              className="h-10 w-auto object-contain"
            />
            <span
              className="font-bold text-white text-xl"
              style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.05em' }}
            >
              MATH TENNIS
            </span>
          </div>
          <p className="text-green-200 text-sm leading-relaxed max-w-xs">
            Where every serve tests your mind. Master multiplication, division, and volume through tennis-style gameplay.
          </p>
        </div>

        {/* Links */}
        <div>
          <h4 className="font-semibold text-lime-300 mb-3 text-sm uppercase tracking-wider">
            Navigation
          </h4>
          <ul className="space-y-2">
            {LINKS.map(link => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-green-200 hover:text-lime-300 text-sm cursor-pointer transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Stats */}
        <div>
          <h4 className="font-semibold text-lime-300 mb-3 text-sm uppercase tracking-wider">
            Challenge Types
          </h4>
          <div className="space-y-3">
            {[
              { icon: 'ri-close-line', label: 'Multiplication', desc: '4 difficulty levels' },
              { icon: 'ri-stack-line', label: 'Volume Problems', desc: 'Shapes & composites' },
              { icon: 'ri-divide-line', label: 'Division', desc: 'From simple to expert' },
            ].map(item => (
              <div key={item.label} className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-green-700 rounded-full">
                  <i className={`${item.icon} text-lime-300`} />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">{item.label}</p>
                  <p className="text-green-300 text-xs">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-green-800">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-green-400 text-xs">
            &copy; {new Date().getFullYear()} Math Tennis Challenge. All rights reserved.
          </p>
          <p className="text-green-400 text-xs">
            Sharpen your skills. Ace every round.
          </p>
        </div>
      </div>
    </footer>
  );
}
